import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-divider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss',
})
export class DividerComponent {
  @Input() direction: 'horizontal' | 'vertical' = 'horizontal';
  @Input() type: 'gray' | 'gold' = 'gray';
}
